import { Actions } from '../actions/analytics';
import { CoolerRecommendation } from '../types/analytics';

const initialState = {};
interface State {
  [key: string]: CoolerRecommendation[];
}

export default (state: State = initialState, action: any) => {
  switch (action.type) {
    case Actions.REFRIGATION_SUCCESS: {
      const { siteId, data } = action.payload;
      if (!siteId) return state;
      return {
        ...state,
        [siteId]: data,
      };
    }

    default:
      return state;
  }
};
